import React from "react"
import cx from "classnames"
import { contrast } from "helpers/contrast"

// Import styles
import "styles/components/common/button.scss"

const Button = ({
  label,
  color,
  type,
  size,
  block,
  ghost,
  outlined,
  hidden,
  onClick,
  loading,
  disabled,
  customClassName,
  fit,
  ...props
}) => {
  if (!label) throw new Error("Button label is required")

  const defaultColor = localStorage.getItem("app-theme")

  let buttonColor
  if (color) {
    buttonColor = color
  } else {
    if (defaultColor) {
      buttonColor = defaultColor
    } else {
      buttonColor = "#f90037"
    }
  }

  const buttonStyle = {}

  if (ghost) {
    buttonStyle.backgroundColor = "transparent"
    buttonStyle.color = buttonColor
  } else {
    buttonStyle.color = "#ffffff"
    buttonStyle.backgroundColor = buttonColor
  }

  if (outlined) {
    buttonStyle.borderColor = buttonColor
    buttonStyle.color = buttonColor
  }

  if (fit) {
    buttonStyle.width = "fit-content"
  }

  let sizeClass = ""
  switch (size) {
    case "xlarge":
      sizeClass = "-xlarge"
      break
    case "large":
      sizeClass = "-large"
      break
    case "medium":
      sizeClass = "-medium"
      break
    case "small":
      sizeClass = "-small"
      break
    case "paddingless":
      sizeClass = "-paddingless"
      break
    default:
      sizeClass = "-medium"
      break
  }

  return (
    <button
      style={buttonStyle}
      className={cx(customClassName, "button-app", {
        disabled,
        block,
        outlined,
        hidden,
        ghost,
        loading,
        [`${sizeClass}`]: true,
        [`is-${contrast(buttonStyle.backgroundColor)}`]: true,
        [`is-${type}`]: type,
      })}
      onClick={onClick}
      {...props}
    >
      {label}
    </button>
  )
}

export default Button
